import { render } from "./lang-toggler-v3.vue?vue&type=template&id=6b1a981c&scoped=true"
import script from "./lang-toggler-v3.vue?vue&type=script&lang=js"
export * from "./lang-toggler-v3.vue?vue&type=script&lang=js"

import "./lang-toggler-v3.vue?vue&type=style&index=0&id=6b1a981c&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b1a981c"]])

export default __exports__